import React, { Component } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import $ from "jquery";
import { Row } from "react-foundation";

import { getDoorRooms } from "actions";
import Loading from "components/Loading";
import InputError from "../../components/InputError";
import Select from "react-select";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";

class SelectRoom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false
        };
    }

    render() {
        let { rooms } = this.props;

        if ($.isEmptyObject(rooms)) {
            return <Loading />;
        }

        if (!this.state.showDropdown) setTimeout(() => this.setState({ showDropdown: true }), 1000);

        let kickoffClasses = "kickoff";
        let dropdownClasses = "dropdown";

        if (this.state.showDropdown) {
            kickoffClasses += " fadeout";
            dropdownClasses += " fadein";
        }

        var options = rooms.map(r => ({ value: r.id, label: r.name }));

        return (
            <div>
                <Row isColumn>
                    <h3 className={kickoffClasses}>{"Okay, let's get started..."}</h3>

                    <h3 className={dropdownClasses}>
                        This is for my
                        <Select
                            onChange={val => this.props.input.onChange(val.value)}
                            options={options}
                            value={this.props.input.value}
                            clearable={false}
                            searchable={false}
                            placeholder=""
                        />
                    </h3>
                </Row>

                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class RoomForm extends Component {
    componentDidMount() {
        // let itemTypeId = 2; // door
        this.props.getDoorRooms();
    }

    render() {

        return (
            <form className="RoomForm" onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <FormHeader title={""} subtitle={""} />
                <SeparatingLine />
                <FormWrapper className="VerticalAlign">
                    <Field name="DoorRoomId" component={SelectRoom} rooms={this.props.rooms} />
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        rooms: state.Door.Rooms
    };
};

export default connect(mapStateToProps, { getDoorRooms })(RoomForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/RoomForm.js